export const ORDER_FULL_NUMBER_PATTERN = /^[PSTEMC]\/20\d{2}\/\d{2}\/\d+$/i

export const isOrderFullNumber = value => ORDER_FULL_NUMBER_PATTERN.test(value)
